import React, { useState, useRef } from 'react';
import "./style.css"

const OTPInput = ({ onComplete, maskedEmail }) => {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const inputsRef = useRef([]);

    const handleChange = (value, index) => {
        if (!/^\d*$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input
        if (value && index < 5) {
            inputsRef.current[index + 1].focus();
        }

        // When all digits are filled
        if (newOtp.every((digit) => digit !== "")) {
            onComplete(newOtp.join(""));
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputsRef.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").trim();

        if (!/^\d{6}$/.test(pasteData)) return; // ensure it's exactly 6 digits

        const newOtp = pasteData.split("");
        setOtp(newOtp);

        newOtp.forEach((digit, idx) => {
            if (inputsRef.current[idx]) {
                inputsRef.current[idx].value = digit;
            }
        });

        // Auto-focus last field
        if (inputsRef.current[5]) {
            inputsRef.current[5].focus();
        }

        // Trigger onComplete
        onComplete(pasteData);
    };


    return (
        <div className="otp_input_0">
            <h4>
                Please Enter The Authentication Code <br />
                Sent To <span style={{ color: "" }}>{maskedEmail}</span>

            </h4>
            <div className='otp_inputs'>
                {otp.map((digit, i) => (
                    <input
                        key={i}
                        type="text"
                        maxLength="1"
                        value={digit}
                        placeholder="•"
                        onChange={(e) => handleChange(e.target.value, i)}
                        onKeyDown={(e) => handleKeyDown(e, i)}
                        onPaste={(e) => handlePaste(e)}
                        ref={(el) => (inputsRef.current[i] = el)}
                    />

                ))}
            </div>
        </div>
    );
};

export default OTPInput;
